import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageBanner from '../components/PageBanner';
import { SITE_CONTENT } from '../content';

const BlogListPage = () => {
  const { pageBanner, blogs } = SITE_CONTENT.pages.blogPage;
  const { logoText } = SITE_CONTENT.global;

  return (
    <div className="min-h-screen bg-[#0a1a0f] text-white">
      <Helmet>
        <title>{pageBanner.title} | {logoText}</title>
        <meta name="description" content="Read the latest news, catering tips, and event insights from Nawabi Caterers." />
        <meta name="keywords" content="catering blog, event planning, Nawabi Caterers news" />
      </Helmet>
      
      <Header />
      <main>
        <PageBanner
          bgImage={pageBanner.bgImage}
          eyebrow={pageBanner.eyebrow}
          title={pageBanner.title}
          breadcrumbs={pageBanner.breadcrumbs}
        />
        
        <section className="py-20 px-6 lg:px-10 max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {blogs.map((blog) => (
              <div key={blog.id} className="group flex flex-col border border-white/10 hover:border-white/30 transition-colors duration-300">
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img 
                    src={blog.image} 
                    alt={blog.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" 
                  />
                  <div className="absolute top-4 left-4 bg-[#0a1a0f]/80 backdrop-blur-sm border border-white/20 px-3 py-1">
                    <span className="text-white text-xs tracking-widest uppercase">{blog.category}</span>
                  </div>
                </div>
                
                <div className="p-8 flex flex-col flex-grow bg-[#071208]">
                  <div className="flex items-center gap-4 text-white/50 text-xs mb-4 uppercase tracking-wider">
                    <span>{blog.date}</span>
                    <span className="w-1 h-1 bg-white/30 rounded-full"></span>
                    <span>{blog.author}</span>
                  </div>
                  
                  <Link to={`/blog/${blog.slug}`}>
                    <h3 className="text-2xl font-light leading-snug mb-4 hover:text-[#c19a5b] transition-colors">
                      {blog.title}
                    </h3>
                  </Link>
                  
                  <p className="text-white/60 text-sm leading-relaxed mb-8 flex-grow">
                    {blog.excerpt}
                  </p>
                  
                  <Link 
                    to={`/blog/${blog.slug}`}
                    className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase hover:text-white/70 transition-colors mt-auto w-fit border-b border-white pb-1"
                  >
                    Read More
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default BlogListPage;
